import { Tooltip } from "@mui/material";
import { FunctionComponent, useState } from "react";
import { useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { SettingsNavListArrowIcon } from "../../icon";
import { Contact } from "../../models/conversations";
import { PlanMetrics } from "../../models/plan-metrics.model";
import { Setting } from '../../models/settings-model';
import * as selector from '../../selectors/selectors';
import { SettingsService } from '../../services/SettingsService';
import { getSettingsMenus } from "../routes/settings.route.config";
import { UserService } from "../../services/UserService";


interface Props {
	slectedMenu: string;
}

const SettingsMenu: FunctionComponent<Props> = (props: Props) => {
	const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)
	const [activeMenu, setActiveMenu] = useState<string>(props.slectedMenu);
	const GetBlockedContacts: Contact[] = useSelector(selector.getBlockedContacts)
	const GetUnSubscribedContacts: Contact[] = useSelector(selector.getUnSubscribedContacts)
	const Settings: Setting[] = useSelector(selector.settings)
	const lowCreditValue = Settings.find(x => x.Code === SettingsService.Low_Credit_Notification)?.Value.toString();
	const blockedContactCount = GetBlockedContacts.length
	const unsubscribedContactCount = GetUnSubscribedContacts.length
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

	return (IsMobileDevice ?
		<nav>
			<ul className="pl-0 mt-0">
				{getSettingsMenus(UserService.getLoggedInUserRole(), PlanMetrics).map((item, index) => {
					const ActiveIcon = item.primaryDarkIcon;
					return (
						<Link
							tabIndex={index === 0 ? 1 : -1}
							data-arrow-index={5 + index}
							data-up-arrow-index={4 + index}
							data-down-arrow-index={index === getSettingsMenus(UserService.getLoggedInUserRole(), PlanMetrics).length - 1 ? 3 : 6 + index}
							data-left-arrow-index={5 + index}
							data-right-arrow-index={200}
							key={item.id} to={item.path} className={"p-relative"}
						>
							<Tooltip title={item.label} placement='bottom'>
								<li key={index} className={`${props.slectedMenu.includes(item.path.replace("/*", "")) ? "sidebar-teams-highlight t-align-center d-flex" : "t-align-center d-flex"} py-3 mobile-list-border-bottom }`} >
									<div className="d-flex justify-between w-p-100">
										<div className="d-flex align-center">
											{!!ActiveIcon &&
												<ActiveIcon className="my-auto mx-2 active-icon" />
											}
											<span key={index} className={`w-space my-auto  color-nav-bar-font-color h4-regular ${item.label.length >= 10 && "flex-wrap"}`}>
												{item.label}
											</span>
										</div>
										<div className="d-flex">
											<div className="mr-2">
												{item.label === "Blocked" && (
													<div className="h5-regular color-settings-mobile-link-text">
														{blockedContactCount} Contacts
													</div>
												)}
												{item.label === "Unsubscribed" && (
													<div className="h5-regular color-settings-mobile-link-text">
														{unsubscribedContactCount} Contacts
													</div>
												)}
											</div>
											<div className="my-auto mr-2 align-center">
												<SettingsNavListArrowIcon />
											</div>
										</div>
									</div>
								</li>
							</Tooltip>
						</Link>
					);
				})}
			</ul>
		</nav>
		:
		<nav className={"nav-bar br-4"} style={{ width: "200px" }}>
			<ul className={`nav-bar-ul d-flex flex-direction o-x-hidden o-y-auto w-p-100 h-p-100 bg-color-primary-background mx-auto`} >
				{
					getSettingsMenus(UserService.getLoggedInUserRole(), PlanMetrics).map((item, index) => {
						const Icon = item.primaryIcon;
						const ActiveIcon = item.primaryDarkIcon;
						return (
							<Link
								tabIndex={index === 0 ? 1 : -1}
								data-arrow-index={5 + index}
								data-up-arrow-index={4 + index}
								data-down-arrow-index={index === getSettingsMenus(UserService.getLoggedInUserRole(), PlanMetrics).length - 1 ? 3 : 6 + index}
								data-left-arrow-index={5 + index}
								data-right-arrow-index={200}
								key={item.id} to={item.path} className={"p-relative"}
							>
								<Tooltip title={item.label} placement='bottom'>
									<li key={index} className={`${props.slectedMenu.includes(item.path.replace("/*", "")) ? "sidebar-teams-highlight t-align-center d-flex" : "t-align-center d-flex"} py-1 ml-1 mt-2 ${props.slectedMenu.includes(item.path.replace("/*", "")) && "navbar-active-link"}`} >
										{!!Icon && !!ActiveIcon &&
											(props.slectedMenu.includes(item.path.replace("/*", "")) ? (
												<ActiveIcon className="my-auto mx-2 active-icon" />
											) : (
												<Icon className="my-auto mx-2" />
											))
										}
										<span key={index} className={`w-space my-auto   ${props.slectedMenu.includes(item.path.replace("/*", "")) ? `${IsDarkMode ? "" : "color-nav-bar-font-color-highlight"} h6-medium` : "color-nav-bar-font-color h6-regular"} ${item.label.length >= 10 && "flex-wrap"}`}>
											{item.label}
										</span>
									</li>
								</Tooltip>
							</Link>
						);
					}
					)
				}
			</ul>
		</nav>
	);
}

export default SettingsMenu